module.exports = __webpack_public_path__ + "img/img5_10.950e872c.jpeg";